// extracted by css-extract-rspack-plugin
export default {"errorBody":"_2ba181a1","body":"_a8806bd9","error":"_94fa4991","errorIcon":"_ec7f061a","secondaryCta":"_bceedd25","footer":"_f1eb9f0c"};